import type { BackendStatus } from '../types';

interface BackendStatusBadgeProps {
  status: BackendStatus;
}

function getStatusClasses(state: BackendStatus['state']): string {
  switch (state) {
    case 'ready':
      return 'bg-emerald-950/60 text-emerald-300 border border-emerald-800/60';
    case 'models_unavailable':
      return 'bg-amber-950/60 text-amber-300 border border-amber-800/60';
    case 'backend_unreachable':
      return 'bg-red-950/60 text-red-300 border border-red-800/60';
    case 'checking':
    default:
      return 'bg-neutral-900 text-neutral-400 border border-neutral-800';
  }
}

export function BackendStatusBadge({ status }: BackendStatusBadgeProps) {
  return (
    <div className={`rounded-lg px-3 py-2 text-xs ${getStatusClasses(status.state)}`}>
      <div className="font-medium">{status.message}</div>
      {status.detail && (
        <div className="mt-1 text-[11px] opacity-80 break-words">{status.detail}</div>
      )}
    </div>
  );
}
